import { FC, useCallback } from 'react';

import { AsyncSearch, StyledTextField } from 'components';
import { searchTruckingCompanies } from 'services';
import { TruckingCompany } from 'types';

import { formatTruckingCompany } from 'utils/format';
import { useNewTransaction } from '..';
import useValidate from '../use-ids';

const TruckingInformation: FC = () => {
  const { transaction, updateTransaction } = useNewTransaction();
  const { validateTruckingCompany } = useValidate();

  const handleSelect = useCallback(
    async (truckingCompany?: TruckingCompany) => {
      if (truckingCompany) {
        const message = await validateTruckingCompany(truckingCompany.id);
        if (message) return message;
      }
      updateTransaction({ truckingCompany });
    },
    [updateTransaction, validateTruckingCompany]
  );

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TRUCKING DETAILS</h4>
      </div>
      <div className="card-body grid-3">
        <div className="col-start-1 col-end-3">
          <AsyncSearch<TruckingCompany>
            required
            label="TRUCKING COMPANY"
            value={transaction?.truckingCompany ?? undefined}
            formatValue={formatTruckingCompany}
            handleSelect={handleSelect}
            search={searchTruckingCompanies}
            data-cy="transaction-trucking-company-search"
          />
        </div>
        <div className="col-start-3">
          <StyledTextField
            fullWidth
            label="TRUCK NUMBER"
            value={transaction.truckNumber ?? ''}
            onChange={e => updateTransaction({ truckNumber: e.target.value })}
            data-cy="transaction-truck-number-input"
          />
        </div>
        <div className="col-start-1 row-start-2">
          <StyledTextField
            fullWidth
            label="DRIVER NAME"
            value={transaction.driverName ?? ''}
            onChange={e => updateTransaction({ driverName: e.target.value })}
            data-cy="transaction-driver-name-input"
          />
        </div>
        <div className="col-start-2 row-start-2">
          <StyledTextField
            fullWidth
            label="LICENSE PLATE"
            value={transaction.licensePlate ?? ''}
            onChange={e => updateTransaction({ licensePlate: e.target.value })}
            data-cy="transaction-truck-license-plate-input"
          />
        </div>
        <div className="col-start-3 row-start-2">
          <StyledTextField
            fullWidth
            label="CDL NUMBER"
            value={transaction.cdlNumber ?? ''}
            onChange={e => updateTransaction({ cdlNumber: e.target.value })}
            data-cy="transaction-cdl-number-input"
          />
        </div>
      </div>
    </div>
  );
};

export default TruckingInformation;
